import {useEffect, useState} from "react";


import {
    BasicButton,
    FullWidthActionButton,
    ThriveIcon,
    IconLibrary,
} from 'thrive-components';
import { useObservable } from 'thrive-observable-react';

import {UserGroupSyncService} from "./UserGroupSync.service.ts";
import {IUserGroupSyncHistory} from "../../../api/UserGroupSync";

import HistoryItem from "./HistoryItem.tsx";
import UserGroupSyncModal from "./UserGroupSyncModal.tsx";


import './UserGroupSync.scss';


const UGSS = new UserGroupSyncService()


const UserGroupSync = () => {
    const [showModal, setShowModal] = useState(false);

    const history = useObservable(UGSS.userSyncHistory);
    const hasMore = useObservable(UGSS.hasMore);

    useEffect(() => {
        UGSS.getHistory();
    }, [])

    return (
        <div className="user-group-sync">
            <div className={'user-group-sync-header'}>
                <h2>User Group Sync History</h2>

                <div className="user-group-sync-header-button-wrapper">
                    <BasicButton
                        content={<div className="user-group-sync-icon-button-wrapper">
                            <ThriveIcon iconName={IconLibrary.DOWNLOAD} sizeInPx={'14'} color={"var(--thriveGreyDark)"} />
                            <span>Download Template</span>
                        </div>}
                        ariaLabel={'Download Template'}
                        isLink={true}
                        linkUrl={'/api/user-group-sync/template'}
                        openInNewTab={true}
                    />

                    <BasicButton
                        isClassicThriveStyle
                        content={'Upload User Group Sync File'}
                        ariaLabel={'Upload'}
                        onButtonClick={() => setShowModal(true)}
                    />
                </div>
            </div>
            <hr/>

            <ul className={'user-group-sync-list'}>
                {history.map((item: IUserGroupSyncHistory , idx: number) => (
                    <HistoryItem
                        key={item.id}
                        item={item}
                        UGSS={UGSS}
                        isLastItem={idx === history.length - 1}
                    />
                ))}
            </ul>

            <div className={'get-more-results-modal-wrapper'}>
                {hasMore &&
                    <FullWidthActionButton
                        onClick={UGSS.getNextPage}
                        text={'Show more results'}
                        label={'Show more results'}
                />
                }
            </div>

            {showModal &&
                <UserGroupSyncModal
                    showModal={showModal}
                    hideModal={() => setShowModal(false)}
                    UGSS={UGSS}
                />
            }
        </div>
    )
}

export default UserGroupSync;